import Building from './Building';

export default Building;
